import { render, staticRenderFns } from "./paramPage.vue?vue&type=template&id=596088e0&scoped=true"
import script from "./paramPage.vue?vue&type=script&lang=js"
export * from "./paramPage.vue?vue&type=script&lang=js"
import style0 from "./paramPage.vue?vue&type=style&index=0&id=596088e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596088e0",
  null
  
)

export default component.exports